import { Pipe, PipeTransform } from '@angular/core';
import { fomatFloat } from 'src/app/helpers/utils';

@Pipe({
  name: 'convertCents'
})
export class ConvertCentsPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    try {
      if (value.length == 1) {
        const roundedValue = value + 0
        return roundedValue
      } else if (value.length == 2) {
        return value
      } else {
        return fomatFloat(`0.${value}`, 2).split('.')[1]
      }
    } catch (error) {
      console.error(error)
      return null
    }
  }
}
